import './App.css';
import {BabylonViewer} from './BabylonViewer';
import {GrowthBookProvider} from "@growthbook/growthbook-react";
import {growthbook} from './GrowthbookClient';
import {useEffect} from "react";

function App() {
  useEffect(() => {
    // Load features asynchronously when the app renders
    growthbook.init({ streaming: true });
    const queryString = window.location.search;
    const parameters = new URLSearchParams(queryString);
    const hasBeta = parameters.has('beta');

    if(hasBeta) {
      growthbook.setAttributes({
        "query": 'beta'
      });
    }
  }, []);
  return (
    <GrowthBookProvider growthbook={growthbook}>
      <BabylonViewer />
    </GrowthBookProvider>
  );
}

export default App;
